<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    title="配件编辑"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="70%"
    top="5%"
    :close-on-click-modal="false"
  >
    <el-row :gutter="20">
      <el-col :span="16">
        <div class="border-style">基本信息</div>
        <el-form
          :model="item"
          ref="itemform"
          label-width="120px"
          :rules="rules"
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="配件名称">
                <el-input
                  v-if="item.IpcAccessoryModel"
                  v-model.trim="item.IpcAccessoryModel.Name"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="品牌">
                <el-input
                  v-if="item.IpcAccessoryModel"
                  v-model.trim="item.IpcAccessoryModel.Brand"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="型号">
                <el-input
                  v-if="item.IpcAccessoryModel"
                  v-model.trim="item.IpcAccessoryModel.ModelNumber"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="关联产品SN">
                <el-input
                  v-if="item.IpcProduct"
                  v-model.trim="item.IpcProduct.SN"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="出库单号" prop="CheckoutNo">
                <el-input
                  v-model.trim="item.CheckoutNo"
                  placeholder="请输入出库单号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="配件SN">
                <el-input v-model.trim="item.SN"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="出库日期" prop="StockoutAt">
                <el-date-picker
                  v-model="item.StockoutAt"
                  style="width: 100%"
                  type="date"
                  placeholder="请选择日期"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="质保开始日期" prop="QualityStartAt">
                <el-date-picker
                  v-model="item.QualityStartAt"
                  style="width: 100%"
                  type="date"
                  placeholder="请选择日期"
                  @change="changeDate"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="客户名称" prop="ClientID">
                <select2
                  labelName="ClientName"
                  v-model="item.ClientID"
                  url="client/list"
                  filterable
                  :clearable="false"
                  placeholder="选择客户"
                  no-data-text="没有客户"
                  :urlParams="{
                    where: {},
                  }"
                  q="ClientName:like"
                  :qinwhere="true"
                  :queryOne="false"
                  style="width: 100%"
                  :currentList="currentClient"
                ></select2>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="质保结束日期" prop="QualityEndAt">
                <el-date-picker
                  v-model="item.QualityEndAt"
                  style="width: 100%"
                  type="date"
                  placeholder="请选择日期"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="出库经办人" prop="Operator">
                <el-input
                  v-model.trim="item.Operator"
                  placeholder="请输入经办人"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="领用人" prop="Recipient">
                <el-input
                  v-model.trim="item.Recipient"
                  placeholder="请输入领用人"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="出库备注" prop="StockoutReason">
            <el-input
              v-model.trim="item.StockoutReason"
              :autosize="{ minRows: 2 }"
              type="textarea"
              placeholder="请输入出库备注"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="文件上传"
            prop="file"
            v-permission="'ipc_accessory_stock-POST'"
            v-if="item.Status !== 1"
          >
            <el-upload
              ref="upload"
              action=""
              :http-request="httpRequest"
              :headers="uploadHeader"
              :on-remove="handleRemove"
              :on-error="handleError"
              :file-list="fileList"
              :on-preview="handlePreview"
            >
              <el-button size="mini" type="primary">选择文件</el-button>
            </el-upload>
          </el-form-item>
          <div style="text-align: right; padding-bottom: 15px">
            <el-button
              type="primary"
              @click="onEdit"
              :disabled="editting"
              size="mini"
              v-permission="'ipc_accessory_stock-POST'"
              v-if="item.Status !== 1"
            >
              <i class="far fa-save"></i> 修改出库信息
            </el-button>
          </div>
        </el-form>

        <div class="border-style">状态信息</div>

        <el-form
          :model="statusItem"
          ref="statusForm"
          label-width="120px"
          :rules="statusRules"
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="状态" prop="Status">
                <select2
                  labelName="Value"
                  valueKey="Key"
                  style="width: 100%"
                  :clearable="false"
                  v-model="statusItem.Status"
                  url="ipc/accessory/stock-status-list"
                  placeholder="请选择状态"
                  :currentList="currentStatus"
                ></select2>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="操作日期" prop="DatedAt">
                <el-date-picker
                  v-model="statusItem.DatedAt"
                  style="width: 100%"
                  type="date"
                  placeholder="请选择日期"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="备注" prop="Reason">
            <el-input
              v-model.trim="statusItem.Reason"
              :autosize="{ minRows: 2 }"
              type="textarea"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>

          <div style="text-align: right">
            <el-button
              type="primary"
              @click="onSubmit"
              :disabled="submitting"
              size="mini"
              v-permission="'ipc_accessory_stock-POST'"
              v-if="item.Status !== 1"
            >
              <i class="far fa-save"></i> 修改状态
            </el-button>
          </div>
        </el-form>
      </el-col>
      <el-col :span="8">
        <div class="dialogDiv">
          <div class="border-style">日志信息</div>
          <el-timeline :reverse="false">
            <el-timeline-item
              v-for="(activity, index) in activities"
              :key="index"
              :timestamp="
                $sys.dateFormat(activity.UpdatedAt) + ' ' + activity.Operator
              "
              placement="top"
            >
              <el-card>
                <p style="margin-top: 0px; margin-bottom: 0px">
                  {{ activity.Content }}
                </p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: _.clone(this.value),
      statusItem: {
        ID: null,
        DatedAt: new Date(),
        Status: -1,
        Reason: "",
      },
      rules: {
        StockoutAt: [
          { required: true, message: "出库日期不能为空", trigger: "blur" },
        ],
        QualityStartAt: [
          { required: true, message: "质保开始日期不能为空", trigger: "blur" },
        ],
        QualityEndAt: [
          { required: true, message: "质保结束日期不能为空", trigger: "blur" },
        ],
        CheckoutNo: [
          { required: true, message: "出库单号不能为空", trigger: "blur" },
        ],
        ClientName: [
          { required: true, message: "客户名称不能为空", trigger: "blur" },
        ],
        // Operator: [
        //   { required: true, message: '出库经办人不能为空', trigger: 'blur' },
        // ],
        Recipient: [
          { required: true, message: "领用人不能为空", trigger: "blur" },
        ],
        StockoutReason: [{ max: 64000, message: "内容过多", trigger: "blur" }],
      },
      statusRules: {
        Status: [{ required: true, message: "状态不能为空", trigger: "blur" }],
        DatedAt: [
          { required: true, message: "操作日期不能为空", trigger: "blur" },
        ],
        Reason: [{ required: true, message: "备注不能为空", trigger: "blur" }],
      },
      pager: {
        total: 0,
        page: 1,
        size: -1,
      },
      editting: false,
      submitting: false,
      activities: [],
      currentStatus: [],
      fileList: [],
      removeList: [],
      index: 0,
      currentClient: [],
      uploadHeader: {
        Authorization: `Bearer ${window.localStorage.getItem("jwtToken")}`,
        Accept: "application/json",
      },
    };
  },
  methods: {
    onOpen() {
      this.item = _.cloneDeep(this.value);

      if (this.item.Attachments && this.item.Attachments.length > 0) {
        this.item.Attachments.forEach((att) => {
          this.index += 1;
          this.fileList.push({
            uid: this.index,
            name: att.Name,
            url: att.Url,
          });
        });
      }

      if (this.item.Client != null) {
        this.currentClient = [
          { ID: this.item.ClientID, ClientName: this.item.Client.ClientName },
        ];
      }

      this.getLog();
      this.getEmptyItem();
    },
    getEmptyItem() {
      this.statusItem.ID = this.item.ID;
      this.statusItem.Status = this.item.Status;
      this.currentStatus = [
        { Key: this.item.Status, Value: this.item.StatusName },
      ];
      this.statusItem.DatedAt = new Date();
      this.statusItem.Reason = "";
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();
      this.$refs.statusForm.resetFields();

      if (this.item.Status !== 1) {
        this.$refs.upload.clearFiles();
      }
      this.fileList = [];
      this.removeList = [];
    },
    getLog() {
      this.$axios
        .get(`ipc/accessory/${this.item.ID}/record`, {
          params: {
            ...this.pager,
            order: ["-updated_at", "-id"],
          },
        })
        .then((response) => {
          this.activities = response.data.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    changeDate(val) {
      //质保开始日期修改，质保结束日期也自动修改,默认质保开始日期开始一年
      if (val) {
        const date = this.item.QualityStartAt;
        this.item.QualityEndAt = new Date(
          date.getTime() + 3600 * 1000 * 24 * 365
        );
      } else {
        this.item.QualityEndAt = val;
      }
    },
    //修改出库信息
    onEdit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.editting = true;

        //排除删除的附件
        if (this.removeList.length !== 0) {
          this.removeList.forEach((url) => {
            this.item.Attachments.splice(
              this.item.Attachments.findIndex((item) => item.Url === url),
              1
            );
          });
          this.$axios.delete("ipc/attachmentDelete", {
            data: { urls: this.removeList },
          });
        }

        this.$emit("input", this.item);
        const itemData = { ...this.item };
        // 保存的操作
        this.$axios
          .request({
            url: `ipc/accessory/stock-out-edit/${this.item.ID}`,
            method: "put",
            data: itemData,
          })
          .then(() => {
            this.$message.success("修改成功");
            this.editting = false;

            if (this.fileList.length > 0) {
              this.$refs.upload.clearFiles();
            }
            this.fileList = [];
            this.removeList = [];
            this.$emit("form:created", true);
            this.$emit("form:saved", true);
            this.$emit("update:visible", false);
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.editting = false;
            this.$emit("form:created", false);
            this.$emit("form:saved", false);
          });
      });
    },
    //修改状态
    onSubmit() {
      this.$refs.statusForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit("input", this.statusItem);
        const itemData = { ...this.statusItem };
        // 保存的操作
        this.$axios
          .request({
            url: "ipc/accessory/stock-status-edit",
            method: "post",
            data: itemData,
          })
          .then(() => {
            this.$message.success("修改成功");
            this.submitting = false;
            this.$emit("form:created", true);
            this.$emit("form:saved", true);
            this.$emit("update:visible", false);
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.submitting = false;
            this.$emit("form:created", false);
            this.$emit("form:saved", false);
          });
      });
    },

    // param是自带参数。 this.$refs.upload.submit() 会自动调用 httpRequest方法.在里面取得file
    httpRequest(params) {
      var formData = new FormData();
      formData.append("file", params.file);
      // formData.append("id", this.item.ID);
      this.$axios
        .post(`ipc/accessory/stock-upload`, formData)
        .then((response) => {
          this.item.Attachments =
            this.item.Attachments === null ? [] : this.item.Attachments;
          this.item.Attachments.push(response.data);

          this.fileList.push({
            uid: params.file.uid,
            name: response.data.Name,
            url: response.data.Url,
          });
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    handleRemove(file) {
      this.fileList.forEach((obj) => {
        if (obj.uid === file.uid) {
          this.removeList.push(obj.url);
          this.fileList.splice(
            this.fileList.findIndex((item) => item.uid === obj.uid),
            1
          );
        }
      });
    },
    handlePreview(file) {
      const a = document.createElement("a");
      a.setAttribute("download", file.name);
      a.setAttribute("href", file.url);
      a.click();
    },
    handleError(err) {
      this.$message.error(err.message.substring(1, err.message.length - 2));
    },
  },
};
</script>
<style scoped>
.dialogDiv {
  height: 650px;
  overflow: auto;
  padding-left: 10px;
  padding-right: 10px;
}
.el-divider--horizontal {
  margin: 12px 0 12px 0;
}
.el-timeline {
  margin: 0;
  font-size: 10px;
  list-style: none;
}
.el-card__body {
  padding: 5px;
}
.el-timeline-item__timestamp {
  color: #909399;
  line-height: 1;
  font-size: 8px;
}
.border-style {
  height: 28px;
  line-height: 28px;
  border-radius: 0 15px 15px 0;
  border-left: 3px solid #409eff;
  padding-left: 5px;
  margin-bottom: 10px;
  background-color: #ecf5ff;
  color: #409eff;
  font-size: 13px;
  font-weight: bolder;
}
</style>
